<script setup lang="ts">
import {
  iconsSrcMap,
  IconType
} from "~/components/TextBlocks/Utility.iconMapping"
const { t } = useI18n()

const benefits = computed((): { icon: IconType; text: string }[] => [
  {
    icon: "priceTag",
    text: t("textBlock.utility.benefit1")
  },
  {
    icon: "shoppingBag",
    text: t("textBlock.utility.benefit2")
  },
  {
    icon: "gift",
    text: t("textBlock.utility.benefit3")
  } //,
  // {
  //   icon: "star",
  //   text: t("textBlock.utility.benefit4")
  // }
])
</script>
<template>
  <section class="utility-wrapper md:grid-standard flex flex-col">
    <div
      class="
        padded
        md:left-padded
        from-green-main
        to-custom-green
        text-white
        flex flex-1 flex-shrink-0 flex-col
        bg-gradient-to-r
        py-8
        md:col-span-8
        md:ml-[-71px]
        md:py-12
        md:pr-0
        lg:ml-[-228px]
      "
    >
      <div class="flex h-full w-full flex-col items-start justify-center gap-8">
        <p class="elephant-bold">{{ $t("textBlock.utility.title") }}</p>

        <p class="pig">
          {{ $t("textBlock.utility.description") }}
        </p>

        <div class="flex flex-col gap-8">
          <div
            v-for="(item, index) in benefits"
            :="item"
            :key="`benefit${index}`"
            class="flex items-center gap-4"
          >
            <div v-if="item.icon" class="icon-circle">
              <UtilsIcon
                v-bind="iconsSrcMap[item.icon]"
                color="tiffany-main"
                class="h-6 w-6 md:h-8 md:w-8"
              />
            </div>

            <span class="pig-bold md:hyppo-bold">
              {{ item.text }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-span-4 flex-1 px-4 py-8 md:pl-6 md:pt-20">
      <div>
        <div class="mb-5 flex w-full flex-col gap-2 md:mb-7 md:gap-4">
          <SkeletonAnimatedPlaceholder
            width="100%"
            height="38px"
            borderRadius="2px"
            class="col-span-full"
          />

          <SkeletonAnimatedPlaceholder
            width="100%"
            height="38px"
            borderRadius="2px"
            class="col-span-full"
          />

          <span class="col-span-full">
            <SkeletonAnimatedPlaceholder
              width="14px"
              height="14px"
              borderRadius="2px"
              class="ml-2"
            />
            {{
              $t(
                "dialogsAndModals.organism.loginAndRegistration.privacyAccept",
                { path: customPaths.privacy }
              )
            }}
          </span>
          <span class="col-span-full">
            <SkeletonAnimatedPlaceholder
              width="14px"
              height="14px"
              borderRadius="2px"
              class="ml-2"
            />
            {{
              $t(
                "dialogsAndModals.organism.loginAndRegistration.subscribeNewsletter"
              )
            }}
          </span>

          <UtilsButton
            :isDisabled="true"
            :text="$t('textBlock.utility.register')"
            class="custom-btn-pig-medium mb-2 w-full"
          />

          <TextBlocksAcceptConditions />
        </div>
      </div>

      <UtilsMarkdown
        :content="
          md
            ? $t('textBlock.utility.or')
            : $t('textBlock.utility.socialRegistration')
        "
        class="beaver text-black-80 py-7 md:pb-4 md:pt-3 md:text-center"
      />

      <div class="flex flex-col gap-2 md:grid md:grid-cols-3 md:flex-row">
        <UtilsButton
          :isDisabled="true"
          :text="$t('textBlock.utility.useIt')"
          class="
            custom-btn-pig-medium
            w-full
            md:[&>span]:h-full
            md:[&>span]:flex-wrap
          "
          theme="outlined-green"
          order="last"
          force-self
        >
          <template #icon>
            <UtilsIcon name="GoogleColored.svg" />
          </template>
        </UtilsButton>

        <UtilsButton
          :isDisabled="true"
          :text="$t('textBlock.utility.useIt')"
          class="
            custom-btn-pig-medium
            w-full
            md:[&>span]:h-full
            md:[&>span]:flex-wrap
          "
          theme="outlined-green"
          order="last"
          force-self
        >
          <template #icon>
            <UtilsIcon name="Facebook.svg" class="text-custom-facebook" />
          </template>
        </UtilsButton>

        <UtilsButton
          :isDisabled="true"
          :text="$t('textBlock.utility.useIt')"
          class="
            custom-btn-pig-medium
            w-full
            md:[&>span]:h-full
            md:[&>span]:flex-wrap
          "
          theme="outlined-green"
          order="last"
          force-self
        >
          <template #icon>
            <UtilsIcon name="AppleBlack.svg" class="mx-1" />
          </template>
        </UtilsButton>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.icon-circle {
  @apply bg-tiffany-10 flex h-10 w-10 flex-shrink-0 items-center justify-center  rounded-full md:h-12 md:w-12;
}
</style>
